import React from "react";
import styles from "./CompanyCard.module.scss";
import Link from "next/link";
import IndustryIcon from "@components/Icons/IndustryIcon";
import Leaves from "@components/Leaves/Leaves";

function getEsgScore(company) {
    const counts = company?.green_step_category_count;
    if (!counts) return 0;
    const values = Object.values(counts);
    if (values.length === 0) return 0;
    return values.reduce((a, b) => a + b, 0) / values.length;
}

function getLineColor(score) {
    if (score >= 60) return "#009448";
    if (score >= 30) return "#E2B93B";
    return "#D8DEDC";
}

export const CompanyCard = ({ company, index = 0 }) => {
    const isLoading = !company;
    const score = company ? getEsgScore(company) : 0;
    const lineColor = company ? getLineColor(score) : "#D8DEDC";

    const cardContent = (
        <div className={styles.cardInner}>
            <div className={styles.logoWrap}>
                {isLoading ? (
                    <div className={styles.logoSkeleton} />
                ) : company?.logo ? (
                    <img
                        src={company.logo}
                        alt={company.name}
                        loading="lazy"
                        width={80}
                        height={80}
                    />
                ) : (
                    <IndustryIcon className={styles.fallbackIcon} />
                )}
            </div>
            {isLoading ? (
                <div className={styles.nameSkeleton} />
            ) : (
                <h5 className={styles.companyName} title={company?.name}>
                    {company?.name}
                </h5>
            )}
            <Leaves
                leafHeight="1.8rem"
                leafWidth="2.6rem"
                laufidCompany={company}
                leafBackground="#fff"
                leafClassName={styles.leaf}
                style={{ justifySelf: "center", alignSelf: "center" }}
            />
        </div>
    );

    return (
        <div
            className={styles.card}
            style={{
                "--line-color": lineColor,
                "--stagger-delay": `${Math.min(index, 11) * 0.04}s`,
            }}
        >
            {company ? (
                <Link
                    href={
                        company?.name
                            ? `/vidskiptavinir/${company.name.replaceAll(" ", "+")}`
                            : ""
                    }
                    className={styles.cardLink}
                >
                    {cardContent}
                </Link>
            ) : (
                cardContent
            )}
        </div>
    );
};
